import pro1 from "../resources/project1.png"
import pro2 from "../resources/project2.png"
import pro3 from "../resources/project3.png"
import pro4 from "../resources/project4.png"
import pro5 from "../resources/project5.png"
import pro6 from "../resources/project6.png"

const projectCardData=[
    // {
    //     img:pro1,
    //     title:"LeafyMart",
    //     text:"Embark on a journey of garden enchantment through our user-friendly web app. Driven by React and Chakra UI, it harmoniously guides you in acquiring seeds, fertilizers, and flowers, elevating your nurturing endeavors.",
    //     techStack:"React | Chakra UI | Axios",
    //     view:"https://648fd6f1bb4a661c5b46aad1--timely-mooncake-09ad75.netlify.app/",
    //     git:"https://github.com/shashi310/habitual-oatmeal-3228",
    // },
    // {
    //     img:pro5,
    //     title:"SkillVantage",
    //     text:"Modern full-stack web app for diverse subjects, career advancement. Access expert-led courses, master new skills, elevate learning journey like Coursera. Join us for vast knowledge exploration.",
    //     techStack:"React | Redux | Chakra UI | Node.js | MongoDB",
    //     view:"https://skillvantage.netlify.app/",
    //     git:"https://github.com/shashi310/synonymous-nose-6503",
    // },
    {
        img:pro6,
        title:"FlashDeal",
        text:"FlashDeal, a React-ChakraUI powered project, replicates Snapdeal's capabilities, empowering users to seamlessly search, purchase, and explore a diverse range of products, delivering an intuitive and hassle-free online shopping experience with enhanced functionalities and user-friendly navigation",
        techStack:"React | Chakra UI |JSON server",
        view:"https://subtle-lollipop-02b2d4.netlify.app/",
        git:"https://github.com/shashi310/FlashDeal",
    },
    {
        img:pro4,
        title:"MedMarket",
        text:"Discover comprehensive medical solutions through our versatile web application. Addressing your every healthcare requirement with convenience and precision, we strive to enhance your well-being effectively and efficiently.",
        techStack:"React | Chakra UI | JSON server",
        view:"https://darling-peony-9dd335.netlify.app/",
        git:"https://github.com/shashi310/frantic-zoo-5736",
    },
    {
        img:pro2,
        title:"Credit Folio",
        text:"The CREDIT-FOLIO React App is a contemporary web platform tailored for efficient credit score management and data organization, offering comprehensive tools and features to monitor, analyze, and manage credit-related information effectively.",
        techStack:"React | Chakra UI | Redux ",
        view:"https://jocular-bavarois-89af42.netlify.app/",
        git:"https://github.com/shashi310/Credit-Folio",
    },
    
    {
        img:pro3,
        title:"Buy from Us",
        text:"A Web Application designed  as B2B E-commerce Platform. explore options from 10 lac plus products, 40 plus B2B categories. Top-Notch Brands | 100% Quality Assured Products | Easy Returns & Replacement and many more",
        techStack:"HTML | CSS | JavaScript ",
        view:"https://bbuyfromus.netlify.app/",
        git:"https://github.com/shashi310/hunky-potato-4915",
    }
    
]

export default projectCardData